import { get } from 'lodash';
import { toUpper } from 'lodash';
import rootStore from '../store/RootStore';
import { measurementUnits } from '@/constants/measurements';
import { convertValue } from '@/utils/util-measurements';

export function useMeasurement() {
  let measurementSystem = get(rootStore.userStore.user, 'measurementSystem', 'METRIC');

  measurementSystem = toUpper(measurementSystem);

  const tunit = (unit = '', toMeasurementSystem = measurementSystem) => {
    return get(measurementUnits, `[${toMeasurementSystem}][${unit}]`, unit);
  };

  const tvalue = (value, unit = '', toMeasurementSystem = measurementSystem, fromMeasurementSystem = 'METRIC') => {
    return convertValue(value, unit, toMeasurementSystem, fromMeasurementSystem);
  };

  return {
    tvalue,
    tunit,
    measurementSystem, // 'Metric' OR 'Imperial'
  };
}
